import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { FunilVendaEtapa } from '../fase/etapa';

@Injectable({
    providedIn: 'root'
})
export class FunilVendaEtapaHttpService {
    private readonly resource = 'crm/funilvenda';
    private readonly pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Carrega a etapa do funil de vendas informado */
    find(idFunilVendaEtapa: number): Observable<FunilVendaEtapa> {
        return this.customHttp.get<FunilVendaEtapa>(`${this.pathApi}/0/etapa/${idFunilVendaEtapa}`);
    }

    /** Pesquisas as etapas do do funil de vendas informado */
    search(idFunilVenda: number, tipoFunilVendaFase: number = null): Observable<FunilVendaEtapa[]> {
        return this.customHttp.get<FunilVendaEtapa[]>(`${this.pathApi}/${idFunilVenda}/etapas/fase/${tipoFunilVendaFase}`);
    }
}
